import Pusher from "pusher-js";
import { getLoggedinUser, logout } from "../userStore";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
const PusherContext = createContext();

const usePusherContext = () => {
  return useContext(PusherContext);
}

const PusherWrapper = ({ children }) => {
  const pusherRef = useRef();
  let pusherKeyObj={};
  if (localStorage.getItem("organization_code")?.toLowerCase()=="hdc"){
    // app_id = "1846029"
    // key = "417ac67c54b658a90f0c"
    // secret = "342701e304eef528c932"
    // cluster = "mt1"
    pusherKeyObj.key="417ac67c54b658a90f0c"
    pusherKeyObj.cluster="mt1"
  }
  else{
    pusherKeyObj.key=process.env.REACT_APP_PUSHER_ENV_KEY
    pusherKeyObj.cluster=process.env.REACT_APP_PUSHER_ENV_CLUSTER
  }
  const pusher = new Pusher(pusherKeyObj.key, {
    cluster:pusherKeyObj.cluster,
  });
  const [pusherData, setPusherData] = useState({});
  const user = getLoggedinUser();
  const authToken = user?.token;

  useEffect(() => {
    if (user) {
      try {
        let channel = null;
        if (!pusherRef.current) {
          channel = pusher.subscribe(user?.uuid);
          channel.bind("my_event", function (data) {
            console.log("****************Pusher Received*****************");
            console.log(data);
            setPusherData(prev => {
              return {
                ...prev,
                [data.msgtype]: data
              }
            });
            if (data?.type == 'user_logged_out' && data?.token == authToken) {
              toast.error('Your session has expired, you will be redirected to Login..');
              setTimeout(() => {
                logout();
              }, 5000);
            }
          });
        }
        if (channel) {
          pusherRef.current = channel;
        }
      } catch (error) {
        console.log(error)
      }

    }
  }, [user]);

  const resetPusherData = () => {
    setPusherData({});
  }

  const defaultValues = {
    pusherData,
    resetPusherData,
  };

  return (
    <PusherContext.Provider value={defaultValues}>
      {children}
    </PusherContext.Provider>
  );
}


export { PusherWrapper as default, usePusherContext, PusherContext};